import { Localization } from "../../../OW.Remoting/Remoting/Localization";
import { EventHelper } from "../../UI.BaseControls/Helpers/EventHelper";
import { createElement, registerCustomElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { Action } from "../Actions/Action";
import { IAction } from "../Actions/IAction";
import { IDropDownMenu, IDropDownMenuItemWithSubmenu } from "./DropDownInterfaces";
import { DropDownMenuItem } from "./DropDownMenuItem";
/**
 * Položka DropDownMenu, která se zkládá ze dvou tlačítek. Levé tlačítko je určeno pro spuštění akce, pravé tlačítko otevírá rozšíření.
 */
export class DropDownMenuComboItem extends DropDownMenuItem implements IDropDownMenuItemWithSubmenu {
    private _submenu: IDropDownMenu;
    private _leftBtn: HTMLButtonElement;
    private _rightBtn: HTMLButtonElement;
    public isClickable: boolean = false;

    public get isEnabled(): boolean {
        return !this.classList.contains("disabled");
    }

    public set isEnabled(val: boolean) {
        this.classList.toggle("disabled", !val);
    }

    public override set locKey(v: string) {
        this._locKey = v;
        if (this._locKey) {
            Localization.getTextPromise(this._locKey).then((locItem) => {
                this._captionElement.textContent = locItem;
            });
        }
    }

    public get submenu(): IDropDownMenu {
        return this._submenu;
    }

    public set submenu(val: IDropDownMenu) {
        this._submenu = val;

        // Nastaveni korenoveho menu
        if (this.parent) {
            if (this.parent.rootMenu)
                this._submenu.rootMenu = this.parent.rootMenu;
            else
                this._submenu.rootMenu = this.parent;
        }
        this.isEnabled = this.action ? this.action.enabledVisual : !!val;
    }

    public override set parent(val: IDropDownMenu) {
        this._parent = val;

        if (this.submenu) {
            if (this._parent.rootMenu)
                this._submenu.rootMenu = this._parent.rootMenu;
            else
                this._submenu.rootMenu = this._parent;
        }
    }

    public override get parent(): IDropDownMenu {
        return this._parent;
    }

    protected override _constructor(): void {
        super._constructor();

        this.visible = true;
    }

    protected override _createElement(): void {
        this.classList.add("dropdown-menu-combo");
        if (!this.submenu)
            this.classList.add("disabled");

        this._textElement = document.createElement("div");
        this._textElement.classList.add("Text");

        this._createIconElement();
        this._createCaptionElement();

        if (this._locKey) {
            Localization.getTextPromise(this._locKey).then((locItem) => {
                this._captionElement.textContent = locItem;
            });
        }
        this._leftBtn = createElement({ type: "button", classes: "btn flat" }) as HTMLButtonElement;
        this._leftBtn.appendChild(this._iconElement);
        this._leftBtn.appendChild(this._textElement);
        this._textElement.appendChild(this._captionElement);

        this._rightBtn = createElement({ type: "button", classes: "btn flat SubMenu" }) as HTMLButtonElement;

        this.appendChild(this._leftBtn);
        this.appendChild(this._rightBtn);
        this._setListener();
    }

    protected override _createCaptionElement(): void {
        this._captionElement = document.createElement("div");
        this._captionElement.classList.add("Caption");

        if (this._locKey) {
            Localization.getTextPromise(this._locKey).then((locItem) => {
                this._captionElement.textContent = locItem;
            });
        }
    }

    public static createDropDownMenuComboItem(icon: string, action: IAction, locKey: string, subMenu: IDropDownMenu, priority: number = 15): DropDownMenuComboItem {
        const element = new DropDownMenuComboItem();

        element.icon = icon;
        element.locKey = locKey;
        element.submenu = subMenu;
        element.priority = priority;
        element._init(element, icon, action, locKey, action.enabled, priority);
        return element;
    }

    protected override _setListener(): void {
        const f_openSubmenu = () => {
            this.parent.openedSubmenu = this.submenu;

            this.submenu.show(this, null);
            this.submenu.lastSelectedItem = this;
        };

        const f_closeSubmenu = () => {
            if (this.parent.openedSubmenu) {
                this.parent.openedSubmenu.close();
                this.parent.openedSubmenu = null;
            }
        };
        if (this._leftBtn) {
            this._leftBtn.addEventListener("click", async (e: MouseEvent) => {
                if (this._leftBtn.classList.contains("Disabled"))
                    return;
                if (e.button === 0) {
                    EventHelper.stopImmediatePropagation(e);

                    if (!this.classList.contains("Disabled")) {
                        if (typeof this.action.execute === "function") {
                            await (this.action as Action).execute();
                        }
                        if (!this.noCloseAfterSelect)
                            this.parent.closeAll();
                    }
                }
            });
        }
        if (this._rightBtn) {
            this._rightBtn.addEventListener("click", (e: MouseEvent) => {
                if (this._rightBtn.classList.contains("Disabled"))
                    return;
                if (e.button === 0) {
                    e.stopImmediatePropagation();
                    if (this.parent.openedSubmenu == this.submenu) {
                        f_closeSubmenu();
                    } else {
                        f_closeSubmenu();
                        f_openSubmenu();
                    }
                }
            });
        }
    }

    public override dispose(): void {
        this.submenu?.dispose();
        super.dispose();
    }
}

registerCustomElement("tsc-DropDownComboItem", DropDownMenuComboItem);
